
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.625 2.45A7.083 7.083 0 111.004 8.812L1 8.583l.004-.23A7.083 7.083 0 0111.625 2.45zM8.083 4.332a.708.708 0 00-.703.626l-.005.083v3.541l.006.093c.017.123.065.24.14.338l.062.07 2.125 2.126.066.058a.708.708 0 00.869 0l.066-.059.059-.066a.708.708 0 000-.869l-.059-.066-1.917-1.919V5.042l-.005-.083a.708.708 0 00-.704-.626z","fill":"#07193D","fill-opacity":".6"}})])
          )
        }
      }
    